import { defineMessages } from 'react-intl';

const prefix = 'app.containers.TranslationSettings.MergeKeys';

export const messages = defineMessages({
  mergeKeyTranslationControlDisabled: {
    id: `${prefix}.mergeKeyTranslationControlDisabled`,
    defaultMessage:
      'Merge key translation control is not enabled for this account',
  },
  panelInstruction: {
    id: `${prefix}.panelInstruction`,
    defaultMessage:
      'Choose which merge key values are translated. Keys not listed here are masked and pass through translation untouched.',
  },
  panelTitle: {
    id: `${prefix}.panelTitle`,
    defaultMessage: 'Merge Key Translation',
  },
});
